// Micro encuesta del 3er PAE (ítem 10 del BACKLOG, OK del fundador
// 2026-08-28): "¿Para qué ramo hiciste este PAE?", EL dato del frente
// universitario. Se muestra UNA vez por usuario, bajo el resumen del PAE
// recién guardado (Rápido o Detallado), con respuestas de CATÁLOGO cerrado
// (RAMOS_PAE) y X para descartar sin insistir. Quién la muestra y cuándo lo
// decide App.jsx con lib/microEncuestas.js (contador de guardados NUEVOS +
// cuota semanal compartida con el NPS); esta card solo pregunta y avisa.
// Vive junto a DisclaimerPAE.jsx: es pieza compartida de los dos PAE.
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import Card from "./foundational/Card";
import IconButton from "./foundational/IconButton";
import { trackEvent } from "../lib/eventTracking";
import {
  RAMOS_PAE, MOMENTO_TERCER_PAE, esRamoValido, consumirEncuestaRamo,
} from "../lib/microEncuestas";

// Mismo respiro que el agradecimiento del NPS: se lee y la card se va sola.
export const MS_GRACIAS_RAMO = 2500;

export default function EncuestaRamo({ userId, modulo, onCerrar, className = "" }) {
  const [estado, setEstado] = useState("pregunta"); // 'pregunta' | 'gracias'

  useEffect(() => {
    if (estado !== "gracias") return undefined;
    const t = setTimeout(() => onCerrar?.(), MS_GRACIAS_RAMO);
    return () => clearTimeout(t);
  }, [estado]); // eslint-disable-line react-hooks/exhaustive-deps

  const responder = (ramo) => {
    if (!esRamoValido(ramo)) return;
    consumirEncuestaRamo({ userId });
    // Un evento por respuesta real, en el handler del toque (patrón #523).
    // `respuesta` es el id del catálogo, jamás texto libre.
    trackEvent("encuesta_momento", { modulo, payload: { momento: MOMENTO_TERCER_PAE, respuesta: ramo } });
    setEstado("gracias");
  };

  const descartar = () => {
    // Descartar consume la cuota igual que responder: no se vuelve a preguntar.
    consumirEncuestaRamo({ userId });
    onCerrar?.();
  };

  return (
    <Card as="section" className={className}>
      {estado === "gracias" ? (
        <p className="text-small text-ink-subtle font-sans" role="status">
          Gracias. Con esto sabemos en qué ramos sirve más MiPAE.
        </p>
      ) : (
        <>
          <div className="flex items-start gap-2">
            <div className="min-w-0 flex-1">
              <p className="text-micro uppercase tracking-wide text-ink-muted font-sans font-semibold">
                Una pregunta rápida
              </p>
              <p className="mt-1 text-small font-semibold text-ink font-sans leading-snug">
                ¿Para qué ramo hiciste este PAE?
              </p>
            </div>
            <IconButton
              icon={<X size={16} strokeWidth={1.6} />}
              ariaLabel="Ahora no, cerrar la pregunta"
              variant="muted"
              onClick={descartar}
              className="-mt-1 -mr-1 flex-shrink-0"
            />
          </div>
          {/* Chips de un toque, mismo dibujo que los atajos de Benito en el Home. */}
          <div className="mt-3 flex flex-wrap gap-2">
            {RAMOS_PAE.map((r) => (
              <button
                key={r.id}
                type="button"
                onClick={() => responder(r.id)}
                className="inline-flex items-center min-h-[44px] rounded-full border border-edge bg-paper px-3.5 py-1.5 text-small font-medium text-ink font-sans hover:border-accent-border hover:text-accent transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
              >
                {r.label}
              </button>
            ))}
          </div>
        </>
      )}
    </Card>
  );
}
